import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import CardLoader from "@/ui/CardLoader";
import React from "react";
import { Link } from "react-router-dom";
import { formatDate, toTitleCase } from "../../utils/helpers";
import { Badge } from "../../components/ui/badge";
import styled from "styled-components";
import Row from "../../ui/Row";
import { useSearch } from "../search/useSearch";
import { searchTypes } from "../search/searchTypes";

const MAX_SUMMARY_LENGTH = 450;

const StyledRow = styled(Row)`
  justify-content: left;
`;

function Recommendations({ searchType, description }) {
  const searchTerm = description;
  const { data, isLoading, isError } = useSearch({
    searchTerm,
    searchType,
  });

  if (isLoading) {
    const skeletonCards = Array.from({ length: 3 }).map((_, index) => (
      <CardLoader key={index} className="h-96" />
    ));
    return (
      <div className="mt-4 grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-3 lg:gap-8">
        {skeletonCards.map((card) => card)}
      </div>
    );
  }

  if (isError) {
    return <div>Error loading recommendations.</div>;
  }

  if (!data || data?.length === 0) {
    return <div>No recommendations available.</div>;
  }

  const recommendations = data.slice(1, 4);

  return (
    <div className="mt-4 grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-3 lg:gap-8">
      {recommendations.map((item) => (
        <RecommendationCard key={item.id} item={item} searchType={searchType} />
      ))}
    </div>
  );
}

function truncateText(text, maxLength) {
  if (text?.length <= maxLength) {
    return text;
  }
  return text?.slice(0, maxLength) + "...";
}

function RecommendationCard({ item, searchType }) {
  const { id, metadata } = item;

  return (
    <Card className="w-full shadow-md">
      <CardHeader className="transition-all ease-in-out duration-300 hover:scale-105">
        <CardTitle>
          <Link to={`/contract/${searchType}/${id}`}>
            {toTitleCase(metadata[searchTypes[searchType].title])}
          </Link>
        </CardTitle>
      </CardHeader>
      <CardContent>
        {metadata[searchTypes[searchType].type] && (
          <CardDescription>
            <StyledRow type="horizontal">
              <>
                <Badge variant="secondary">
                  {metadata[searchTypes[searchType].type]}
                </Badge>
              </>
            </StyledRow>
          </CardDescription>
        )}
        <br />
        {metadata[searchTypes[searchType].due] && (
          <CardDescription>
            <strong>Due on:</strong>{" "}
            {formatDate(metadata[searchTypes[searchType].due])}
          </CardDescription>
        )}
        <br />
        <CardDescription>
          {truncateText(
            metadata[searchTypes[searchType].summary],
            MAX_SUMMARY_LENGTH
          )}
        </CardDescription>
      </CardContent>
    </Card>
  );
}

export { Recommendations };
